export default __webpack_public_path__ + "static/media/3435 knife block C top.2cc92704.png";